import React, { type FC } from 'react'

interface IProps {
  stroke: string
}

const PreviousSVG: FC<IProps> = ({ stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='9'
      height='16'
      viewBox='0 0 9 16'
      fill='none'
    >
      <path
        d='M7.68086 14.7827L1 7.88978L7.68086 1'
        stroke={stroke}
        strokeMiterlimit='10'
      />
    </svg>
  )
}

export default PreviousSVG
